//local imports
import { Messenger } from "@app/shared";
import { ToastLevel, ToastMessage } from "@app/components";
import {
  CatalogStateService,
  CategoryModel,
  CategoryAddedMessage,
  CategoryUpdatedMessage,
  RefreshFilterMessage,
} from "@app/catalog";

import {
  CategoryCreatedNotification,
  CategoryUpdatedNotification
} from "@app/catalog-common";


export class CategoryStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      CategoryCreatedNotification,
      (message: CategoryCreatedNotification) => {
        let category = new CategoryModel();

        category.id = message.id;

        category.name.set(message.name);

        this.updateCategory(category, message);

        catalogStateService.CatalogManagementState.categories.set([
          category,
          ...catalogStateService.CatalogManagementState.categories(),
        ]);

        messenger.send(
          ToastMessage.create(
            new CategoryAddedMessage(category),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    messenger.subscribe(
      catalogStateService,
      CategoryUpdatedNotification,
      (message: CategoryUpdatedNotification) => {
        let category =
          catalogStateService.CatalogManagementState.categories().find(
            (u) => u.id === message.id,
          );

        if (!category) {
          category = new CategoryModel();
          category.id = message.id;

          category.name.set(message.name);
        }

        this.updateCategory(category, message);

        messenger.send(new RefreshFilterMessage());
        messenger.send(
          ToastMessage.create(
            new CategoryUpdatedMessage(category),
            ToastLevel.Information,
          ),
        );
      },
    );
  }

  private updateCategory(
    category: CategoryModel,
    message: CategoryCreatedNotification | CategoryUpdatedNotification,
  ) {
    //TODO:DIW:Move into it's own class..
    //TODO:DIW:Set properties by reading changed properties collection and mapping..

    for (let change of message.changes) {
      if (change.propertyName.toLowerCase() === "name") {
        category.name.set(change.newValue);
      }
    }
  }
}
